var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1860_5177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5027 26.613C34.5745 24.0111 38.4194 22.0285 38.7508 21.8743C39.8109 21.3476 40.9058 19.9534 38.7508 18.8705C38.055 18.5299 34.3089 16.6091 29.5027 14.1318L22.8398 20.4187L29.5027 26.6129V26.613Z",
    fill: "#FFD900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8402 20.4189L1.625 40.396C2.12297 40.4576 2.68516 40.3343 3.34797 39.9938C4.73953 39.2822 19.4914 31.7553 29.503 26.6147L22.8402 20.4189Z",
    fill: "#F43249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8399 20.4188L29.5027 14.1629C29.5027 14.1629 4.83992 1.58757 3.34773 0.845236C2.78555 0.534141 2.15555 0.441733 1.5918 0.534141L22.8399 20.4188Z",
    fill: "#00EE76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8392 20.4189L1.59109 0.53418C0.72875 0.720457 0 1.43228 0 2.88805V38.0421C0 39.3745 0.563906 40.3342 1.62406 40.4267L22.8392 20.4189Z",
    fill: "#00D3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1860_5177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/Google-play.aa6853648b657c7528df329c41620cbe.svg";
export { ForwardRef as ReactComponent };